import { CART_UPDATE, CART_CLEAR } from './constants';
import { encode, decode, mergeDedupe } from 'utilities';
import { CART_DATA } from 'CONSTANTS';

export const cartUpdate = cart => ({
  type: CART_UPDATE,
  cart
});

export const cartClear = () => ({
  type: CART_CLEAR,
});

export const cartAddWorker = item => (dispatch, getState) => {
  const { cart, auth } = getState();
  const storageKey = CART_DATA + '_' + auth.user.id;
  const enhancedItem = { ...item, $quantity: 1 };
  const newCart = {
    ...cart,
    elements: {
      ...cart.elements,
      [item.id]: enhancedItem
    },
    ids: mergeDedupe([...cart.ids, item.id])
  }

  localStorage.setItem(storageKey, encode(JSON.stringify(newCart)));
  dispatch(cartUpdate(newCart));
};

export const cartRemoveWorker = item => (dispatch, getState) => {
  const { cart, auth } = getState();
  const storageKey = CART_DATA + '_' + auth.user.id;
  const newCart = {
    ...cart,
    elements: {
      ...cart.elements,
    },
    ids: cart.ids.filter(el => el !== item.id)
  }
  delete newCart.elements[item.id];

  localStorage.setItem(storageKey, encode(JSON.stringify(newCart)));
  dispatch(cartUpdate(newCart));
};

export const cartQuantityWorker = (id, quantity) => (dispatch, getState) => {
  const { cart, auth } = getState();
  const storageKey = CART_DATA + '_' + auth.user.id;
  const enhancedItem = { ...cart.elements[id], $quantity: parseInt(quantity > 9999 ? 9999 : quantity, 10) };  
  const newCart = {
    ...cart,
    elements: {
      ...cart.elements,
      [id]: enhancedItem
    },
  }

  localStorage.setItem(storageKey, encode(JSON.stringify(newCart)));
  dispatch(cartUpdate(newCart));
};

export const cartInitWorker = () => (dispatch, getState) => {
  const { auth } = getState();
  if(!auth.user) return;
  const storageKey = CART_DATA + '_' + auth.user.id;
  const storageItem = localStorage.getItem(storageKey);
  if(!storageItem) return false;

  const cart = JSON.parse(decode(storageItem));
  dispatch(cartUpdate(cart));
}

export const cartClearWorker = () => (dispatch, getState) => {
  const { auth } = getState();
  const storageKey = CART_DATA + '_' + auth.user.id;
  localStorage.removeItem(storageKey);
  dispatch(cartClear());
}



// WEBPACK FOOTER //
// ./src/ducks/cart/actions.js